<template>
    <div class='user-menu'>
        <div class="head-top">
            <span>菜单设置</span>
            <div>
                <el-button @click="submitMenu" type="primary">保存</el-button>
                <el-button @click="back" type="primary">返回</el-button>
            </div>
        </div>
        <div class="menu-list">
            <el-tree :data="list" :default-checked-keys="hasIds" :highlight-current="true" @check="handleCheckChange" show-checkbox default-expand-all node-key="menuId" ref="tree" highlight-current
                :props="defaultProps">
            </el-tree>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        userId: {
            type: String,
            default: ""
        },
        menuType: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            list: [],
            menuIds:[],
            hasIds:[],
            defaultProps: {
                children: 'children',
                label: 'menuName'
            }
        }
    },
    mounted() {

    },
    created() {
        this.getPermissionMenuByUserId();
    },
    methods: {
        back() { 
            this.$router.push({
                name:"permissionUser"
            })
        },
        handleCheckChange(data, checked) {
            this.menuIds = checked.checkedKeys;
            this.menuIds = this.menuIds.concat(checked.halfCheckedKeys);
            console.log(this.menuIds);
        },
        getPermissionMenuByUserId() { 
            this.$http.post('/api/XOrg/PermissionUser/getPermissionMenuByUserId',{
                userId: this.userId,
                menuType: this.menuType
            }).then(rst => { 
                if (rst.code > 0) {
                    this.list = rst.userMenuPermission;
                    this.hasIds = rst.permissionUserMenuIds;
                    this.hasIds = this.hasIds.filter(menuId => !this.list.some(element => element.menuId === menuId));
                    console.log(this.hasIds);
                }
            })
        },
        submitMenu() { 
            this.$http.post('/api/XOrg/PermissionUser/savePermissionUserMenu', {
                userId: this.userId,
                menuIds: this.menuIds
            }).then(rst => {
                if (rst.code > 0) {
                    this.getPermissionMenuByUserId();
                    this.$message.success(rst.msg);
                } else {
                    this.$message.error(rst.msg);
                }
            })
        },
    },
}
</script>
<style lang='scss' >
.user-menu{
    min-height: 100%;
    background: #fff;
    .menu-list{
        width: 400px;
        padding: 0 20px 20px;
    }
    .head-top{
        position: relative;
        padding: 0 20px 0 10px;
        margin-left: 20px;
        line-height: 50px;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        &::before{
            content: "";
            position: absolute;
            left: 0;
            top: 18px;
            width: 3px;
            height: 14px;
            background: #2d82ff;
        }
    }
}

</style>
